export enum EntryAction {
  RATE = 'rate',
  AWARD = 'award',
  BUY = 'buy',
  REJECT = 'reject',
  RECONSIDER = 'reconsider',
  LIKE = 'like',
  DISLIKE = 'dislike',
}

export interface ContestViewEntriesUpdateActionRawPayload {
  readonly action: EntryAction;
  readonly rating?: number;
}
